const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.multipleUserEdit.hideModal()
  }
}

export default OnEscape
